import { Tooltip } from '@mui/material';
import type { ImageProps } from 'next/image';

export type AccreditationBadgeProps = {
  src: string;
  height?: number;
  width?: number;
  FlexibleImageComponent: React.ComponentType<ImageProps>;
  translatedText: {
    tooltipText: string;
  };
};

/**
 * Props for the AccreditationBadge component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @param {AccreditationBadgeProps} props - The props for the AccreditationBadge component.
 * @param {React.ComponentType<ImageProps>} FlexibleImageComponent - The image component to use.
 * @param {string} translatedText.tooltipText - The text to display in the tooltip.
 * @example translatedText.tooltipText:
 * ```tsx
 * const tooltipText = t("appDetails:accreditationBadgeText", {
    accreditationName
  });
  
 * @returns {JSX.Element} The AccreditationBadge component.
 */
export const AccreditationBadge = ({
  src,
  height,
  width,
  translatedText,
  FlexibleImageComponent,
}: AccreditationBadgeProps) => {
  return (
    <Tooltip title={translatedText.tooltipText}>
      <FlexibleImageComponent
        src={src}
        alt={translatedText.tooltipText}
        height={height ?? '64'}
        width={width ?? '64'}
        style={{ fontSize: '.8rem', wordBreak: 'break-all' }}
      />
    </Tooltip>
  );
};
